import { Box, Button, Typography } from '@mui/material';
import { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { PageHeader } from '../../components/PageHeader';
import { ActivityAndHealth, SummaryPanel } from './SummaryPanel';
import type { TileFilter } from './SummaryPanel';
import { UnitList } from './UnitList';
import type { View } from './UnitList';

/**
 * "Full Inventory Dashboard" ("Real-time overview of your inventory"), opened with View Full
 * Dashboard (walks of 2026-10-23 and 2026-10-27): the tiles, the four charts, SIM & Device
 * Add/Update Activity, Inventory Health and the Quick Reports. A tile opens its list filtered.
 */
export function FullInventoryDashboardPage() {
  const [view, setView] = useState<View>('sim');
  const [opened, setOpened] = useState(0);
  const [filter, setFilter] = useState<TileFilter | undefined>();
  const listRef = useRef<HTMLDivElement>(null);
  // A tile opens its list filtered to its status (or eSIM / physical), as on the reference.
  const open = (target: 'sim' | 'device', tileFilter?: TileFilter) => {
    setView(target);
    setFilter(tileFilter);
    setOpened((n) => n + 1);
    listRef.current?.scrollIntoView?.({ behavior: 'smooth', block: 'start' });
  };
  return (
    <Box>
      <PageHeader
        title="Full Inventory Dashboard"
        code="PC345"
        actions={
          <Button component={Link} to="/inventory">
            Inventory Dashboard
          </Button>
        }
      />
      <Typography color="text.secondary" sx={{ mb: 1.5 }}>
        Real-time overview of your inventory
      </Typography>
      <SummaryPanel onOpen={open} />
      <ActivityAndHealth />
      <Box ref={listRef} component="section" aria-labelledby="quick-reports">
        <Typography id="quick-reports" variant="h3" sx={{ mb: 1 }}>
          Quick Reports
        </Typography>
        <UnitList
          key={opened}
          view={view}
          onViewChange={setView}
          views={['sim', 'device', 'product']}
          filter={filter}
        />
      </Box>
    </Box>
  );
}
